import { FC, HTMLProps, useEffect, useRef } from 'react'
import styled from 'styled-components'

interface IndeterminateCheckboxProps extends HTMLProps<HTMLInputElement> {
  indeterminate?: boolean
  className?: string
}

const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid ${({ theme }) => theme.colors.primaryColor300};
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  position: relative;
  &:checked {
    outline: none;
    border: none;
    background: ${({ theme }) => theme.colors.primaryColor300};
    &:checked::after {
      content: '✔';
      color: black;
      position: absolute;
      left: 3px;
      top: 1px;
      font-size: 16px;
      line-height: 1;
    }
  }
  &:indeterminate {
    outline: none;
    background: transparent;
    border-color: ${({ theme }) => theme.colors.warningColor300};
  }
  &:indeterminate::after {
    outline: none;
    content: '';
    position: absolute;
    left: 3px;
    top: 7px;
    width: 10px;
    height: 2.5px;
    background: ${({ theme }) => theme.colors.warningColor300};
    border-radius: 2px;
    display: block;
  }
  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primaryColor100};
  }
` as React.ForwardRefExoticComponent<
  React.InputHTMLAttributes<HTMLInputElement> & React.RefAttributes<HTMLInputElement>
>

const IndeterminateCheckbox: FC<IndeterminateCheckboxProps> = ({
  indeterminate,
  className = '',
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [indeterminate, rest.checked])

  return <StyledCheckbox ref={ref} className={className + ' cursor-pointer'} {...rest} />
}

export default IndeterminateCheckbox
